module.exports = __webpack_public_path__ + "img/our1.689e69f0.svg";